import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var DoNotHaveRequestedInfoIA = function DoNotHaveRequestedInfoIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.Account.NOT_OPEN ? articlePage(articles.Account.NOT_OPEN.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [DO_NOT_HAVE_INFO_NEEDED(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "ici5fB",
    defaultMessage: [{
      "type": 0,
      "value": "Partilhar informações para verificar a sua conta"
    }]
  });
};
var DO_NOT_HAVE_INFO_NEEDED = function DO_NOT_HAVE_INFO_NEEDED(strictLocalize) {
  return strictLocalize({
    id: "fbjw9s",
    defaultMessage: [{
      "type": 0,
      "value": "Não tem todas as informações necessárias para verificar a sua conta neste momento? Não há problema. Informe-nos e iremos reter a sua encomenda até 30 dias a partir da data em que efetuou a encomenda, enquanto obtém as informações necessárias."
    }]
  });
};